import { render, staticRenderFns } from "./home_09m.vue?vue&type=template&id=204a0adc&scoped=true&"
import script from "./home_09m.vue?vue&type=script&lang=js&"
export * from "./home_09m.vue?vue&type=script&lang=js&"
import style0 from "./home_09m.vue?vue&type=style&index=0&id=204a0adc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a0adc",
  null
  
)

/* custom blocks */
import block0 from "./home_09m.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports